module.exports = __webpack_public_path__ + "static/media/14.a0f9f120.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/14.png
// module id = 795
// module chunks = 0